<!-- Square SE - most recent version - 1 vue app/bundle (css + js) & bootstrap 4 + init in migdal -->
<template>
    <div v-if="!state.isMobile && seBarLayout === LayoutEnum.HORIZONTAL"  class="w-100 position-sm-absolute" style="z-index: 999">
        <div id="horizontal-se-grid-parent-wrapper" class="p-3" style="gap: 15px">
            <div id="horizontal-se-grid-wrapper" :class="store.state.summer && 'SUMMER'" class="position-relative z-index-10">
                <section id="horizontal-se-autocomplete" class="z-index-2">
                    <Autocomplete
                        v-if="state.showAutoComplete"
                        :customTopStations="customTopStations"
                        :locale="store.state.locale"
                        :se="se"
                        :store="store"
                        :contents="localStore.contents"
                        :dropdownWidth="dropdownWidth"
                    />
                </section>

                <section id="horizontal-se-start-date" class="z-index-2">
                    <StartDate class="tf-border-rounded--md" :store="localStore" :events="controls.startDate" @select="onSelectStartDate"></StartDate>
                </section>

                <section id="horizontal-se-end-date" class="z-index-2">
                    <EndDate class="tf-border-rounded--md" :store="localStore" :events="controls.endDate" @shown="onOpenEndDate"></EndDate>
                </section>

                <section id="horizontal-se-participants" class="z-index-2">
                    <Participants
                        class="tf-border-rounded--md"
                        :store="localStore"
                        :control="controls.participants"
                        :dropdownWidth="dropdownWidth"
                    ></Participants>
                </section>

                <section id="horizontal-se-formule-ski" class="z-index-2" v-if="!localStore.state.summer">
                    <DropdownItems 
                        
                        :automation-id="'ski-formula'"
                        :classes-toggle="{
                            'tf-border-rounded--md': true
                        }"
                        :store="localStore"
                        :filter="filters.packages"
                        :label="localStore.contents.placeHolders.packages"
                    >
                    </DropdownItems>
                </section>
            </div>
            <div class="d-flex flex-row nowrap align-items-center" style="gap: 10px">
                <a
                    class="button-primary primary-normal"
                    @click="trackSearchButtonClick"
                    :href="
                        !localStore.state.summer
                            ? localStore.contents.resultsUrl + '#' + resultsUrl
                            : localStore.contents.resultsUrlSummer + '#' + resultsUrl
                    "
                    style="gap: 10px"
                >
                    <MagnifyingGlassIcon></MagnifyingGlassIcon>

                    <span>
                        {{ localStore.contents.search }}
                    </span>
                </a>
                <button class="ts-x-black ts-x-lg" @click="reset"></button>
            </div>
            <div style="border-radius: 10px" class="position-absolute loader" v-if="store.state.loading"></div>
        </div>
    </div>

    <div v-else-if="seBarLayout === LayoutEnum.PACKAGE" class="w-100 position-sm-absolute" style="z-index: 999">
        <div class="position-relative z-index-10">
            <section class="z-index-1 w-100 top-0 left-0">
                <div class="row no-gutters d-flex justify-content-center" :style="{ color: packColor_primary }">
                    <p class="p-2 heading text-center">
                        <template v-if="packCode === 'PF'">{{ localStore.contents.package.title_PF }}</template>
                        <template v-else-if="packCode === 'PFP'">{{ localStore.contents.package.title_PFP }}</template>
                    </p>
                </div>
            </section>

            <div class="z-index-2 se-main">
                <div
                    class="position-relative"
                    :class="{
                        'z-index-2': !state.mobileExpanded
                    }"
                    ref="wrap"
                >
                    <div ref="top"></div>
                    <template v-if="state.isMobile && (!state.mobileExpanded || state.scrollBelowTop)">
                        <div
                            class="p-3 bg-primary-white border-default shadow-3"
                            :class="{
                                'position-fixed top-0 left-0 right-0': state.scrollBelowTop
                            }"
                            @click="expandMobile"
                        >
                            <div
                                class="dropdown border-default bg-primary-white region-dropdown d-flex justify-content-between"
                                id="dropdown-container"
                            >
                                <div class="d-flex align-items-center">
                                    {{ localStore.contents.title }}
                                </div>
                                <div class="d-flex align-items-center">
                                    <MagnifyingGlassIcon></MagnifyingGlassIcon>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div
                        class="se-main position-relative"
                        v-if="!state.isMobile || state.mobileExpanded"
                        :class="{
                            'se-main--expanded': state.expanded,
                            'd-none': state.isMobile && state.scrollBelowTop
                        }"
                    >
                        <!-- <div
                            class="offset-4 col-8 position-absolute top-0 left-0 bottom-0 d-none d-lg-flex d-flex align-items-center justify-content-center se-main__promo-area"
                        >
                            <a :href="localStore.contents.promoLink">
                                <img :src="localStore.contents.promoImg" />
                            </a>
                        </div> -->

                        <div class="z-index-2 pack-main-grid">
                            <section id="pack-boxes" :style="{ color: packColor_primary }" class="z-index-2">
                                <div class="pack-box-wrapper d-flex justify-content-center flex-row nowrap align-items-center">
                                    <div class="pack-box">
                                        <HebergementSVG :color="packColor_primary"></HebergementSVG>
                                        <span class="body-strong">
                                            {{ localStore.contents.package.accomodation }}
                                        </span>
                                        <span :style="{ color: packColor_primary, fontWeight: 400 }" class="default">
                                            7 {{ localStore.contents.package.days }}
                                        </span>
                                    </div>
                                    <div class="pack-plus">
                                        <span>
                                            <PlusSVG :color="packColor_primary"></PlusSVG>
                                        </span>
                                    </div>
                                    <div class="pack-box">
                                        <SkipassSVG :color="packColor_primary"></SkipassSVG>
                                        <span class="body-strong">
                                            {{ localStore.contents.package.skipass }}
                                        </span>
                                        <span :style="{ color: packColor_primary, fontWeight: 400 }" class="default">
                                            6 {{ localStore.contents.package.days }}
                                        </span>
                                    </div>
                                    <template v-if="packCode === 'PFP'">
                                        <div class="pack-plus">
                                            <span>
                                                <PlusSVG :color="packColor_primary"></PlusSVG>
                                            </span>
                                        </div>
                                        <div class="pack-box">
                                            <MaterielSVG :color="packColor_primary"></MaterielSVG>
                                            <span class="body-strong">
                                                {{ localStore.contents.package.equipment }}
                                            </span>
                                            <span :style="{ color: packColor_primary, fontWeight: 400 }" class="default">
                                                6 {{ localStore.contents.package.days }}
                                            </span>
                                        </div>
                                    </template>
                                </div>
                            </section>

                            <!-- <section id="pack-price-box">
                                <div class="price-box w-100" :style="{ backgroundColor: packColor_100 }">
                                    <span class="default" :style="{ color: packColor_primary, }">price box</span>
                                </div>
                            </section>

                            <section id="pack-price-box-disclaimer">
                                <div>
                                    <span class="subcaption">*disclaimer</span>
                                </div>
                            </section> -->

                            <section v-if="!state.isMobile" id="pack-autocomplete" class="z-index-2">
                                <Autocomplete
                                    v-if="state.showAutoComplete"
                                    :customTopStations="customTopStations"
                                    :locale="store.state.locale"
                                    :se="se"
                                    :store="store"
                                    :contents="localStore.contents"
                                />
                            </section>

                            <section v-if="state.isMobile" id="pack-region" ref="packRegion">
                                <!-- Region -->
                                <div class="px-1 pt-1 tab-dropdown" ref="regionsInput" @click="openRegionsDropdown">
                                    <DropdownInputHeader
                                        class="tf-border-rounded--md"
                                        :placeholder="localStore.contents.placeHolders.regions"
                                        :label="regionLabel"
                                        :events="controls.regionsHeader"
                                        :has-value="!!store.data.selected.region"
                                        :data-id="'region-input'"
                                        @input="(e) => controls.regionsTabsAutocomlete.fire('filter', e)"
                                        @clear="clearRegions"
                                        @keyup="regionsInputOnKeyUp"
                                    >
                                        <span slot="icon-left">
                                            <GeoIcon></GeoIcon>
                                        </span>
                                        <span slot="icon-right">
                                            <ArrowUp v-show="!state.regionsDropdownIsOpen" />
                                            <ArrowDown v-show="state.regionsDropdownIsOpen" />
                                        </span>
                                    </DropdownInputHeader>
                                </div>
                                <!-- Regions dropdown -->
                                <div class="px-1">
                                    <div class="regions-dropdown" ref="regionsDropdown">
                                        <div
                                            class="dropdown-menu min-w-100 p-0 overflow-hidden"
                                            ref="regionsDropdownMenu"
                                            style="min-width: 300px"
                                            @click.stop
                                            :class="{
                                                show: state.regionsDropdownIsOpen
                                            }"
                                        >
                                            <TabsAutocomplete
                                                :tabs="regionTabs"
                                                :events="controls.regionsTabsAutocomlete"
                                                :selected="store.data.selected.region"
                                                :is-selected="isRegionSelected"
                                                @select="selectRegion"
                                            >
                                            </TabsAutocomplete>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section v-if="state.isMobile" id="pack-station">
                                <!-- Station -->
                                <div class="col-12 p-1">
                                    <Stations :store="localStore" @openStations="onRegionsDropdownClose"></Stations>
                                </div>
                            </section>

                            <!-- Participants -->
                            <section id="pack-participants" class="col-12 no-gutters">
                                <Participants class="tf-border-rounded--md" :store="localStore" :control="controls.participants"></Participants>
                            </section>

                            <section id="pack-start" class="d-flex flex-row nowrap no-gutters">
                                <!-- Date de depart -->
                                <StartDate
                                    class="w-100 tf-border-rounded--md"
                                    :store="localStore"
                                    :events="controls.startDate"
                                    @select="onSelectStartDate"
                                ></StartDate>
                            </section>

                            <section id="pack-end" class="d-flex flex-row nowrap no-gutters">
                                <!-- Date de retour -->
                                <EndDate
                                    class="w-100 tf-border-rounded--md"
                                    :store="localStore"
                                    :events="controls.endDate"
                                    @shown="onOpenEndDate"
                                ></EndDate>
                            </section>

                            <section id="pack-reset" class="z-index-1 py-1">
                                <!-- SEARCH AND CLEAR  -->
                                <div
                                    :style="{ color: packColor_primary }"
                                    id="reset-button"
                                    class="link-small text-nowrap cursor-pointer d-flex align-items-center cursor-pointer"
                                    @click="reset"
                                >
                                    <button
                                        :style="{ color: packColor_primary }"
                                        class="ts-x-sm bg-primary-white"
                                        :class="
                                            packColor_primary.includes('green')
                                                ? 'ts-x-green'
                                                : packColor_primary.includes('orange')
                                                ? 'ts-x-orange'
                                                : 'ts-x-blue'
                                        "
                                    ></button>
                                    <span class="px-1">{{ localStore.contents.reset }}</span>
                                </div>
                                <!-- END SEARCH AND CLEAR  -->
                            </section>

                            <section id="pack-search">
                                <a
                                    :style="{ backgroundColor: packColor_primary, gap: '8px' }"
                                    id="search-button"
                                    class="w-100 d-flex button-primary primary-normal se-search justify-content-center"
                                    @click="trackSearchButtonClick"
                                    :href="resultsUrlPackCode"
                                    >
                                    <MagnifyingGlassIcon></MagnifyingGlassIcon>
                                    <span>
                                        {{ localStore.contents.search }}
                                    </span>
                                </a>
                            </section>
                        </div>

                        <!-- LOADING -->
                        <div class="position-absolute loader" v-if="store.state.loading"></div>
                        <!-- END LOADING -->
                    </div>
                    <div
                        class="z-index-3 position-absolute edge-to-edge bg-white tf-transition-all-500 pointer-events-none"
                        v-if="state.opaque"
                        :class="{
                            'opacity-10': state.opaque === 1,
                            'opacity-1': state.opaque === 2
                        }"
                    ></div>
                </div>
            </div>
        </div>
    </div>

    <div v-else class="w-100 position-sm-absolute" style="z-index: 999">
        <div class="position-relative z-index-10">
            <section v-if="localStore.contents.searchEngineTitleTag === 'p'" class="z-index-1 w-100 top-0 left-0">
                <div v-if="state.isMobile" class="d-xl-none body-strong text-primary-blue">
                    <p class="p-2 body-strong text-primary-blue" v-html="localStore.contents.searchEngineTitle">
                        {{ localStore.contents.searchEngineTitle }}
                    </p>
                </div>
                <div v-else class="row no-gutters d-none d-xl-flex">
                    <p class="p-2 body-strong text-primary-blue" v-html="localStore.contents.searchEngineTitle">
                        {{ localStore.contents.searchEngineTitle }}
                    </p>
                </div>
            </section>
            <section v-else class="z-index-1 w-100 top-0 left-0">
                <div v-if="state.isMobile" class="d-xl-none body-strong text-primary-blue">
                    <h1 class="p-2 body-strong text-primary-blue" v-html="localStore.contents.searchEngineTitle">
                        {{ localStore.contents.searchEngineTitle }}
                    </h1>
                </div>
                <div v-else class="row no-gutters d-none d-xl-flex">
                    <h1 class="p-2 body-strong text-primary-blue" v-html="localStore.contents.searchEngineTitle">
                        {{ localStore.contents.searchEngineTitle }}
                    </h1>
                </div>
            </section>
            <div class="z-index-2 se-main">
                <div
                    class="position-relative"
                    :class="{
                        'z-index-2': !state.mobileExpanded
                    }"
                    ref="wrap"
                >
                    <div ref="top"></div>
                    <template v-if="state.isMobile && (!state.mobileExpanded || state.scrollBelowTop)">
                        <div
                            class="p-3 bg-primary-white border-default shadow-3"
                            :class="{
                                'position-fixed top-0 left-0 right-0': state.scrollBelowTop
                            }"
                            @click="expandMobile"
                        >
                            <div
                                class="dropdown border-default bg-primary-white region-dropdown d-flex justify-content-between"
                                id="dropdown-container"
                            >
                                <div class="d-flex align-items-center">
                                    {{ localStore.contents.title }}
                                </div>
                                <div class="d-flex align-items-center">
                                    <MagnifyingGlassIcon></MagnifyingGlassIcon>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div
                        class="se-main row no-gutters position-relative"
                        v-if="!state.isMobile || state.mobileExpanded"
                        :class="{
                            'se-main--expanded': state.expanded,
                            'd-none': state.isMobile && state.scrollBelowTop
                        }"
                    >
                        <!-- <div
                            class="offset-4 col-8 position-absolute top-0 left-0 bottom-0 d-none d-lg-flex d-flex align-items-center justify-content-center se-main__promo-area"
                        >
                            <a :href="localStore.contents.promoLink">
                                <img :src="localStore.contents.promoImg" />
                            </a>
                        </div> -->

                        <div class="col-12 z-index-2 position-static se-main__side">
                            <div
                                class="d-flex d-xl-none align-items-center justify-content-end text-white se-main__title-area"
                                style="display: none !important"
                            >
                                <!-- TODO UNCOMMENT WHEN WE DECIDE TO IMPLEMENT MOBILE -->
                                <!-- <button class="d-xl-none ts-x-black px-2 cursor-pointer" @click="collapseMobile"></button> -->
                                <!-- END TODO UNCOMMENT WHEN WE DECIDE TO IMPLEMENT MOBILE -->
                            </div>

                            <section class="z-index-2">
                                <div class="row no-gutters pt-3">
                                    <template v-if="!state.isMobile">
                                        <div class="px-1">
                                            <Autocomplete
                                                v-if="state.showAutoComplete"
                                                :customTopStations="customTopStations"
                                                :locale="store.state.locale"
                                                :se="se"
                                                :store="store"
                                                :contents="localStore.contents"
                                            />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <!-- Region -->
                                        <div class="px-1 pt-1 tab-dropdown" ref="regionsInput" :class="localStore.state.summer ? 'col-12' : 'col-6'" @click="openRegionsDropdown">
                                            <DropdownInputHeader
                                                class="tf-border-rounded--md"
                                                :placeholder="localStore.contents.placeHolders.regions"
                                                :label="regionLabel"
                                                :events="controls.regionsHeader"
                                                :has-value="!!store.data.selected.region"
                                                :data-id="'region-input'"
                                                @input="(e) => controls.regionsTabsAutocomlete.fire('filter', e)"
                                                @clear="clearRegions"
                                                @keyup="regionsInputOnKeyUp"
                                            >
                                                <span slot="icon-left">
                                                    <GeoIcon></GeoIcon>
                                                </span>
                                                <span slot="icon-right">
                                                    <ArrowUp v-show="!state.regionsDropdownIsOpen" />
                                                    <ArrowDown v-show="state.regionsDropdownIsOpen" />
                                                </span>
                                            </DropdownInputHeader>
                                            <!-- Regions dropdown -->
                                            <div class="regions-dropdown" ref="regionsDropdown">
                                                <div
                                                    class="dropdown-menu min-w-100 p-0 overflow-hidden"
                                                    ref="regionsDropdownMenu"
                                                    style="min-width: 300px"
                                                    @click.stop
                                                    :class="{
                                                        show: state.regionsDropdownIsOpen
                                                    }"
                                                >
                                                    <TabsAutocomplete
                                                        :tabs="regionTabs"
                                                        :events="controls.regionsTabsAutocomlete"
                                                        :selected="store.data.selected.region"
                                                        :is-selected="isRegionSelected"
                                                        @select="selectRegion"
                                                    >
                                                    </TabsAutocomplete>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Domaine Skiable -- only displayed for winter season-->
                                        <div v-if="!localStore.state.summer" class="col-6 p-1" @click="closeDropdowns">
                                            <Domains
                                                class=""
                                                :classes-select="{
                                                    'tf-border-rounded--md': true
                                                }"
                                                @open="onRegionsDropdownClose"
                                                :store="localStore"
                                            ></Domains>
                                        </div>

                                        <!-- Station -->
                                        <div class="col-12 p-1">
                                            <Stations :store="localStore" @openStations="onRegionsDropdownClose"></Stations>
                                        </div>
                                    </template>
                                    <!-- POI -- only displayed for summer season-->
                                    <!-- <div v-if="localStore.state.summer" class="col-12 p-1">
                                        <Poi
                                            class=""
                                            :classes-select="{
                                                'tf-border-rounded--md': true
                                            }"
                                            :store="localStore"
                                            :filter="filters.poi"
                                        ></Poi>
                                    </div> -->

                                    <!-- Date de depart -->
                                    <div class="col-6 p-1">
                                        <StartDate
                                            class="tf-border-rounded--md"
                                            :store="localStore"
                                            :events="controls.startDate"
                                            @select="onSelectStartDate"
                                        ></StartDate>
                                    </div>
                                    <!-- Date de retour -->
                                    <div class="col-6 p-1">
                                        <EndDate
                                            class="tf-border-rounded--md"
                                            :store="localStore"
                                            :events="controls.endDate"
                                            @shown="onOpenEndDate"
                                        ></EndDate>
                                    </div>
                                    <!-- Participants -->
                                    <div class="col-12 p-1">
                                        <Participants
                                            class="tf-border-rounded--md"
                                            :store="localStore"
                                            :control="controls.participants"
                                        ></Participants>
                                    </div>
                                    <!-- Formule Ski only displayed for winter season-->
                                    <div class="col-12 p-1" v-if="!localStore.state.summer">
                                        <DropdownItems
                                            :automation-id="'ski-formula'"
                                            :classes-toggle="{
                                                'tf-border-rounded--md': true
                                            }"
                                            :store="localStore"
                                            :filter="filters.packages"
                                            :label="
                                                localStore.contents.placeHolders.packages
                                            "
                                        >
                                        </DropdownItems>
                                    </div>
                                    <!-- Type d'hebergement  removed for now-->
                                    <div class="col-12 p-1">
                                        <DropdownItems
                                            :automation-id="'lodging-type'"
                                            :classes-toggle="{
                                                'tf-border-rounded--md': true
                                            }"
                                            :store="localStore"
                                            :filter="filters.lodgingType"
                                            :label="localStore.contents.placeHolders.lodgingType"
                                        >
                                            <span slot="icon-left" class="me-2">
                                                <HebergementSVG :color="'#585F66'" :width="'20'"></HebergementSVG>
                                            </span>
                                        </DropdownItems>
                                    </div>
                                </div>
                            </section>

                            <section class="z-index-1 py-3 2 d-flex align-items-center justify-content-between bg-xl-none tf-transition-all-500">
                                <!-- OPEN CRITERIAS BUTTONS -->
                                <div class="order-2 order-xl-1 text-white font-12 font-weight-bold cursor-pointer" style="display: none">
                                    <div class="text-nowrap" v-show="!state.expanded" @click="expand">
                                        <i class="fas fa-plus-circle"></i>
                                        <span class="ps-1">{{ localStore.contents.expand }}</span>
                                    </div>
                                    <div class="text-nowrap" v-show="state.expanded" @click="collapse">
                                        <i class="fas fa-minus-circle"></i>
                                        <span class="ps-1">{{ localStore.contents.collapse }}</span>
                                    </div>
                                </div>
                                <!-- END OPEN CRITERIAS BUTTONS -->

                                <!-- SEARCH AND CLEAR  -->
                                <div class="d-flex align-items-center justify-content-between w-100">
                                    <div
                                        id="reset-button"
                                        class="link-small text-nowrap cursor-pointer d-flex align-items-center cursor-pointer"
                                        @click="reset"
                                    >
                                        <button class="ts-x-blue ts-x-sm bg-primary-white"></button>
                                        <span class="px-1">{{ localStore.contents.reset }}</span>
                                    </div>
                                    <a
                                        id="search-button"
                                        @click="trackSearchButtonClick"
                                        class="d-flex ml-3 button-primary primary-normal se-search justify-content-around"
                                        :href="
                                            !localStore.state.summer
                                                ? localStore.contents.resultsUrl + '#' + resultsUrl
                                                : localStore.contents.resultsUrlSummer + '#' + resultsUrl
                                        "
                                    >
                                        <MagnifyingGlassIcon></MagnifyingGlassIcon>

                                        <span>
                                            {{ localStore.contents.search }}
                                        </span>
                                    </a>
                                </div>
                                <!-- END SEARCH AND CLEAR  -->
                            </section>
                        </div>
                        <!-- CRITERIAS -->
                        <section
                            class="d-none col-12 col-xl-8 z-index-1 pb-3 pb-xl-0 text-white tf-transition-all-500 se-main__side se-main__side-right"
                        >
                            <div class="d-none d-xl-block se-main__title-area"></div>
                            <div class="se-top-bar d-flex w-100 p-0 d-none d-xl-block"></div>
                            <section class="row w-100 m-0">
                                <div class="d-none d-xl-block col-12 col-xl-4 mt-3">
                                    <Slider :store="localStore" :filter="filters.distanceSlopes"></Slider>
                                    <Slider class="mt-4" :store="localStore" :filter="filters.distanceCenterCity"></Slider>
                                    <Slider class="mt-4" :store="localStore" :filter="filters.distanceSkiSchool"></Slider>
                                </div>
                                <div class="col-12 col-xl-3 mt-3">
                                    <div class="w-100 font-weight-bold font-15">
                                        {{ localStore.contents.topServices }}
                                    </div>
                                    <div class="row justify-content-around ps-lg-2 mt-3">
                                        <div
                                            class="col-4 mb-4 d-flex flex-column align-items-center p-0"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.tv) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-secondary cursor-not-allowed': !isAvailable(filters.tv),
                                                'cursor-pointer': isAvailable(filters.tv)
                                            }"
                                            @click="toggle(filters.tv)"
                                        >
                                            <div
                                                class="d-flex align-items-center justify-content-center font-22 border-2 tf-btn--circle-2"
                                                :class="{
                                                    'text-blue bg-white': isSelected(filters.tv),
                                                    'text-secondary border-secondary': !isAvailable(filters.tv),
                                                    'bg-hover--light-blue': isAvailable(filters.tv) && !isSelected(filters.tv)
                                                }"
                                            >
                                                <!-- <i class="fas fa-tv fa-fw"></i> -->
                                                <div class="se-sprite picto tv"></div>
                                            </div>
                                            <span class="mt-1 text-center font-12 font-xl-14">
                                                {{ filters.tv.label }}
                                            </span>
                                        </div>
                                        <div
                                            class="col-4 mb-4 d-flex flex-column align-items-center p-0"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.swimmingPool) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-secondary cursor-not-allowed': !isAvailable(filters.swimmingPool),
                                                'cursor-pointer': isAvailable(filters.swimmingPool)
                                            }"
                                            @click="toggle(filters.swimmingPool)"
                                        >
                                            <div
                                                class="d-flex align-items-center justify-content-center font-24 border-2 tf-btn--circle-2"
                                                :class="{
                                                    'text-blue bg-white': isSelected(filters.swimmingPool),
                                                    'text-secondary border-secondary': !isAvailable(filters.swimmingPool),
                                                    'bg-hover--light-blue': isAvailable(filters.swimmingPool) && !isSelected(filters.swimmingPool)
                                                }"
                                            >
                                                <i class="fas fa-swimming-pool"></i>
                                            </div>
                                            <span class="mt-1 text-center font-12 font-xl-14">
                                                {{ filters.swimmingPool.label }}
                                            </span>
                                        </div>
                                        <div
                                            class="col-4 mb-4 d-flex flex-column align-items-center p-0"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.balcony) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-secondary cursor-not-allowed': !isAvailable(filters.balcony),
                                                'cursor-pointer': isAvailable(filters.balcony)
                                            }"
                                            @click="toggle(filters.balcony)"
                                        >
                                            <div
                                                class="d-flex align-items-center justify-content-center font-24 border-2 tf-btn--circle-2"
                                                :class="{
                                                    'text-blue bg-white': isSelected(filters.balcony),
                                                    'text-secondary border-secondary': !isAvailable(filters.balcony),
                                                    'bg-hover--light-blue': isAvailable(filters.balcony) && !isSelected(filters.balcony)
                                                }"
                                            >
                                                <i class="fas fa-umbrella-beach"></i>
                                            </div>
                                            <span class="mt-1 text-center font-12 font-xl-14">
                                                {{ filters.balcony.label }}
                                            </span>
                                        </div>
                                        <div
                                            class="col-4 mb-4 d-flex flex-column align-items-center p-0"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.animalsAllowed) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-secondary cursor-not-allowed': !isAvailable(filters.animalsAllowed),
                                                'cursor-pointer': isAvailable(filters.animalsAllowed)
                                            }"
                                            @click="toggle(filters.animalsAllowed)"
                                        >
                                            <div
                                                class="d-flex align-items-center justify-content-center font-24 border-2 tf-btn--circle-2"
                                                :class="{
                                                    'text-blue bg-white': isSelected(filters.animalsAllowed),
                                                    'text-secondary border-secondary': !isAvailable(filters.animalsAllowed),
                                                    'bg-hover--light-blue': isAvailable(filters.animalsAllowed) && !isSelected(filters.animalsAllowed)
                                                }"
                                            >
                                                <span class="tf-icon-animaux"></span>
                                            </div>
                                            <span class="mt-1 text-center font-12 font-xl-14">
                                                {{ filters.animalsAllowed.label }}
                                            </span>
                                        </div>
                                        <div
                                            class="col-4 mb-4 d-flex flex-column align-items-center p-0"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.wiFi) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-secondary cursor-not-allowed': !isAvailable(filters.wiFi),
                                                'cursor-pointer': isAvailable(filters.wiFi)
                                            }"
                                            @click="toggle(filters.wiFi)"
                                        >
                                            <div
                                                class="d-flex align-items-center justify-content-center font-24 border-2 tf-btn--circle-2"
                                                :class="{
                                                    'text-blue bg-white': isSelected(filters.wiFi),
                                                    'text-secondary border-secondary': !isAvailable(filters.wiFi),
                                                    'bg-hover--light-blue': isAvailable(filters.wiFi) && !isSelected(filters.wiFi)
                                                }"
                                            >
                                                <span class="tf-icon-wifi"></span>
                                            </div>
                                            <span class="mt-1 text-center font-12 font-xl-14">
                                                {{ filters.wiFi.label }}
                                            </span>
                                        </div>
                                        <div
                                            class="col-4 mb-4 d-flex flex-column align-items-center p-0"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.cleaning) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-secondary cursor-not-allowed': !isAvailable(filters.cleaning),
                                                'cursor-pointer': isAvailable(filters.cleaning)
                                            }"
                                            @click="toggle(filters.cleaning)"
                                        >
                                            <div
                                                class="d-flex align-items-center justify-content-center font-24 border-2 tf-btn--circle-2"
                                                :class="{
                                                    'text-blue bg-white': isSelected(filters.cleaning),
                                                    'text-secondary border-secondary': !isAvailable(filters.cleaning),
                                                    'bg-hover--light-blue': isAvailable(filters.cleaning) && !isSelected(filters.cleaning)
                                                }"
                                            >
                                                <span class="tf-icon-lave"></span>
                                            </div>
                                            <span class="mt-1 text-center font-12 font-xl-14">
                                                {{ filters.cleaning.label }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row"></div>
                                </div>
                                <div class="col-12 col-xl-5 mt-3">
                                    <div class="row px-3">
                                        <div class="col-12 w-100 font-weight-bold font-15 mb-2 p-0">
                                            {{ localStore.contents.roomsNumber }}
                                        </div>
                                        <div class="col-12 row no-gutters ml-0 p-0 justify-content-between">
                                            <div
                                                class="col border font-14 border-white text-center ml-0 mr-1"
                                                data-placement="top"
                                                data-toggle="tooltip"
                                                :title="!isAvailable(filters.sleepingRooms1) && localStore.contents.unavailableTooltip"
                                                :class="{
                                                    'text-blue bg-white cursor-pointer': isSelected(filters.sleepingRooms1),
                                                    'bg-hover--light-blue cursor-pointer': isAvailable(filters.sleepingRooms1),
                                                    'text-gray cursor-not-allowed': !isAvailable(filters.sleepingRooms1)
                                                }"
                                                @click="isAvailable(filters.sleepingRooms1) && toggle(filters.sleepingRooms1)"
                                            >
                                                {{ filters.sleepingRooms1.label }}
                                            </div>
                                            <div
                                                class="col border font-14 border-white text-center ml-0 mr-1"
                                                data-placement="top"
                                                data-toggle="tooltip"
                                                :title="!isAvailable(filters.sleepingRooms2) && localStore.contents.unavailableTooltip"
                                                :class="{
                                                    'text-blue bg-white cursor-pointer': isSelected(filters.sleepingRooms2),
                                                    'bg-hover--light-blue cursor-pointer': isAvailable(filters.sleepingRooms2),
                                                    'text-gray cursor-not-allowed': !isAvailable(filters.sleepingRooms2)
                                                }"
                                                @click="isAvailable(filters.sleepingRooms2) && toggle(filters.sleepingRooms2)"
                                            >
                                                {{ filters.sleepingRooms2.label }}
                                            </div>
                                            <div
                                                class="col border font-14 border-white text-center ml-0 mr-1"
                                                data-placement="top"
                                                data-toggle="tooltip"
                                                :title="!isAvailable(filters.sleepingRooms3) && localStore.contents.unavailableTooltip"
                                                :class="{
                                                    'text-blue bg-white': isSelected(filters.sleepingRooms3),
                                                    'bg-hover--light-blue cursor-pointer': isAvailable(filters.sleepingRooms3),
                                                    'text-gray cursor-not-allowed': !isAvailable(filters.sleepingRooms3)
                                                }"
                                                @click="isAvailable(filters.sleepingRooms3) && toggle(filters.sleepingRooms3)"
                                            >
                                                {{ filters.sleepingRooms3.label }}
                                            </div>
                                            <div
                                                class="col border font-14 border-white text-center ml-0 mr-1"
                                                data-placement="top"
                                                data-toggle="tooltip"
                                                :title="!isAvailable(filters.sleepingRooms4) && localStore.contents.unavailableTooltip"
                                                :class="{
                                                    'text-blue bg-white': isSelected(filters.sleepingRooms4),
                                                    'bg-hover--light-blue cursor-pointer': isAvailable(filters.sleepingRooms4),
                                                    'text-gray cursor-not-allowed': !isAvailable(filters.sleepingRooms4)
                                                }"
                                                @click="isAvailable(filters.sleepingRooms4) && toggle(filters.sleepingRooms4)"
                                            >
                                                {{ filters.sleepingRooms4.label }}
                                            </div>
                                            <div class="dropdown tf-select col border font-14 border-white text-center m-0 p-0">
                                                <div class="dropdown tf-select w-100 h-100 tf-border-rounded">
                                                    <div
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                        data-toggle="dropdown"
                                                        class="h-100 text-nowrap cursor-pointer dropdown-toggle p-0"
                                                        :class="{
                                                            'text-blue bg-white': filters.sleepingRooms.items.find((item) => isSelected(item)),
                                                            'text-gray': !filters.sleepingRooms.items.find((item) => isAvailable(item))
                                                        }"
                                                    >
                                                        5+
                                                    </div>
                                                    <ul
                                                        class="p-0 text-dark-blue font-14 list-unstyled dropdown-menu dropdown-menu-right min-w-100 overflow-auto se-main__sleeping-rooms-dropdown"
                                                        @click.stop
                                                    >
                                                        <li
                                                            class="text-nowrap px-3 py-2"
                                                            data-placement="top"
                                                            data-toggle="tooltip"
                                                            :title="!isAvailable(item) && localStore.contents.unavailableTooltip"
                                                            :class="{
                                                                'bg-gray': isSelected(item),
                                                                'bg-secondary cursor-not-allowed': !isAvailable(item),
                                                                'bg-hover--light-blue cursor-pointer': isAvailable(item)
                                                            }"
                                                            v-for="item in filters.sleepingRooms.items"
                                                            :key="item.label"
                                                            @click="isAvailable(item) && toggle(item)"
                                                        >
                                                            <span
                                                                class="mr-2"
                                                                :class="{
                                                                    'text-light-blue': isSelected(item)
                                                                }"
                                                                v-show="isSelected(item)"
                                                            >
                                                                <i class="fas fa-check-square"></i>
                                                            </span>
                                                            <span
                                                                class="mr-2"
                                                                :class="{
                                                                    'text-gray': !isSelected(item)
                                                                }"
                                                                v-show="!isSelected(item)"
                                                            >
                                                                <i class="fas fa-square"></i>
                                                            </span>
                                                            {{ item.label }}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row px-3 mt-3">
                                        <div class="col-12 w-100 font-weight-bold font-15 mb-2 p-0">
                                            {{ localStore.contents.rating }}
                                        </div>
                                        <div
                                            class="border font-10 border-white rounded-left text-center py-1 px-2 col-3"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailableAvgRating(filters.avgRating2) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-blue bg-white': isSelectedValue(filters.avgRating2),
                                                'bg-secondary cursor-not-allowed': !isAvailableAvgRating(filters.avgRating2),
                                                'bg-hover--light-blue cursor-pointer': isAvailableAvgRating(filters.avgRating2)
                                            }"
                                            @click="isAvailableAvgRating(filters.avgRating2) && toggleFieldValue(filters.avgRating2)"
                                        >
                                            {{ filters.avgRating2.label }}
                                        </div>
                                        <div
                                            class="border font-10 border-white border-left-0 text-center py-1 px-2 col-3"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailableAvgRating(filters.avgRating3) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-blue bg-white': isSelectedValue(filters.avgRating3),
                                                'bg-secondary cursor-not-allowed': !isAvailableAvgRating(filters.avgRating3),
                                                'bg-hover--light-blue cursor-pointer': isAvailableAvgRating(filters.avgRating3)
                                            }"
                                            @click="isAvailableAvgRating(filters.avgRating3) && toggleFieldValue(filters.avgRating3)"
                                        >
                                            {{ filters.avgRating3.label }}
                                        </div>
                                        <div
                                            class="border font-10 border-white border-left-0 text-center py-1 px-2 col-3"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailableAvgRating(filters.avgRating4) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-blue bg-white': isSelectedValue(filters.avgRating4),
                                                'bg-secondary cursor-not-allowed': !isAvailableAvgRating(filters.avgRating4),
                                                'bg-hover--light-blue cursor-pointer': isAvailableAvgRating(filters.avgRating4)
                                            }"
                                            @click="isAvailableAvgRating(filters.avgRating4) && toggleFieldValue(filters.avgRating4)"
                                        >
                                            {{ filters.avgRating4.label }}
                                        </div>
                                        <div
                                            class="border font-10 border-white border-left-0 rounded-right text-center py-1 px-2 col-3"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailableAvgRating(filters.avgRating5) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-blue bg-white': isSelectedValue(filters.avgRating5),
                                                'bg-secondary cursor-not-allowed': !isAvailableAvgRating(filters.avgRating5),
                                                'bg-hover--light-blue cursor-pointer': isAvailableAvgRating(filters.avgRating5)
                                            }"
                                            @click="isAvailableAvgRating(filters.avgRating5) && toggleFieldValue(filters.avgRating5)"
                                        >
                                            {{ filters.avgRating4.label }}
                                        </div>
                                    </div>
                                    <div class="row px-3 mt-3 mb-3 mb-xl-0">
                                        <div class="col-12 w-100 font-weight-bold font-15 mb-2 p-0">
                                            {{ localStore.contents.food }}
                                        </div>
                                        <div
                                            class="cursor-pointer border font-10 border-white rounded-left text-center py-1 px-2 col-3"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.breakfast) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-blue bg-white': isSelected(filters.breakfast),
                                                'bg-hover--light-blue': isAvailable(filters.breakfast),
                                                'text-white bg-secondary cursor-not-allowed': !isAvailable(filters.breakfast)
                                            }"
                                            v-html="filters.breakfast.label"
                                            @click="isAvailable(filters.breakfast) && toggle(filters.breakfast)"
                                        ></div>
                                        <div
                                            class="cursor-pointer border font-10 border-white border-left-0 text-center py-1 px-2 col-3"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.fullBoard) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-blue bg-white': isSelected(filters.fullBoard),
                                                'bg-hover--light-blue': isAvailable(filters.fullBoard),
                                                'text-white bg-secondary cursor-not-allowed': !isAvailable(filters.fullBoard)
                                            }"
                                            v-html="filters.fullBoard.label"
                                            @click="isAvailable(filters.fullBoard) && toggle(filters.fullBoard)"
                                        ></div>
                                        <div
                                            class="cursor-pointer border font-10 border-white border-left-0 border-right-0 text-center py-1 px-2 col-3"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.allInclusive) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-blue bg-white': isSelected(filters.allInclusive),
                                                'bg-hover--light-blue': isAvailable(filters.allInclusive),
                                                'text-white bg-secondary cursor-not-allowed': !isAvailable(filters.allInclusive)
                                            }"
                                            v-html="filters.allInclusive.label"
                                            @click="isAvailable(filters.allInclusive) && toggle(filters.allInclusive)"
                                        ></div>
                                        <div
                                            class="cursor-pointer border font-10 border-white rounded-right text-center py-1 px-2 col-3"
                                            data-placement="top"
                                            data-toggle="tooltip"
                                            :title="!isAvailable(filters.snowCaterer) && localStore.contents.unavailableTooltip"
                                            :class="{
                                                'text-blue bg-white': isSelected(filters.snowCaterer),
                                                'bg-hover--light-blue': isAvailable(filters.snowCaterer),
                                                'text-white bg-secondary cursor-not-allowed': !isAvailable(filters.snowCaterer)
                                            }"
                                            v-html="filters.snowCaterer.label"
                                            @click="isAvailable(filters.snowCaterer) && toggle(filters.snowCaterer)"
                                        ></div>
                                    </div>
                                </div>
                            </section>
                        </section>
                        <!-- END CRITERIAS -->
                        <!-- LOADING -->
                        <div class="position-absolute loader" v-if="store.state.loading"></div>
                        <!-- END LOADING -->
                    </div>
                    <div
                        class="z-index-3 position-absolute edge-to-edge bg-white tf-transition-all-500 pointer-events-none"
                        v-if="state.opaque"
                        :class="{
                            'opacity-10': state.opaque === 1,
                            'opacity-1': state.opaque === 2
                        }"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// libs
import Events from '../../../../libs/events'
import { onClickOutside } from '@vueuse/core'

// bl-components
import Domains from '@se/bl-components/filters/domains.vue'
import Poi from '@se/bl-components/filters/poi.vue'
import Stations from '@se/bl-components/filters/stations-v2.vue'
import StartDate from '@se/bl-components/filters/start-date.vue'
import EndDate from '@se/bl-components/filters/end-date.vue'
import Participants from '@se/bl-components/filters/participants.vue'
import DropdownItems from '@se/bl-components/filters/dropdown-items.vue'
import Slider from '@se/bl-components/filters/slider.vue'
import Regions from '@se/bl-components/filters/regions.vue'
import Autocomplete from '@se/bl-components/filters/autocomplete/index.vue'

// components
import DropdownInputHeader from '@se/components/dropdown-input-header.vue'
import TabsAutocomplete from '@se/components/tabs-autocomplete.vue'
import MagnifyingGlassIcon from '@se/components/svg/se/magnifying-glass/index.vue'
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import GeoIcon from '@se/components/svg/common/geo/index.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMagnifyingGlass, faRotateRight } from '@fortawesome/free-solid-svg-icons'

// svg
import HebergementSVG from '../../components/svg/package/HebergementSVG.vue'
import SkipassSVG from '../../components/svg/package/SkipassSVG.vue'
import MaterielSVG from '../../components/svg/package/MaterielSVG.vue'
import PlusSVG from '../../components/svg/package/PlusSVG.vue'

// Dto
import SeStoreDTO from "@se/tracking/dto/SeStoreDTO"

// Tracking
import trackSearchEvent from "@se/tracking/trackSearchEvent"

library.add(faMagnifyingGlass, faRotateRight)

// bl logic
import getRegionsTabsAutocomplete from '@se/bl/tabs-autocomplete/regions'

// logic
import {
    setAutocompleteValueListener,
    setParentStationsValueListener,
    setStationsValueListener,
    setRegionsValueListener,
    emitAutocompleteValue,
    emitRegionsValue,
    emitParentStationsValue,
    emitStationsValue
} from '../../logic/globalizeValues'

import {getStartOfWinterDate} from "../../logic/getStartOfWinterDate"

// enum
import { LayoutEnum } from '../../enums/LayoutEnum'

// config
import { packColorConfig_primary, packColorConfig_100 } from '../../config/packColorConfig'
import {nextSeasonButtonMonthStart,nextSeasonButtonMonthEnd} from "../../config/defaults"



// services

export default {
    name: 'SeMain',
    components: {
        // bl-components
        Domains,
        Poi,
        Stations,
        StartDate,
        EndDate,
        Participants,
        DropdownItems,
        Slider,
        Regions,
        MagnifyingGlassIcon,

        // components
        DropdownInputHeader,
        TabsAutocomplete,
        FontAwesomeIcon,
        Autocomplete,
        ArrowUp,
        ArrowDown,
        GeoIcon,

        HebergementSVG,
        SkipassSVG,
        MaterielSVG,
        PlusSVG
    },
    props: {
        store: Object,
        contents: Object,
        filters: Object,
        fieldCounters: Array,
        criteriaCounters: Array,
        expandedCriteriaCounters: Array,
        defaultParticipantsAges: Array,
        defaultCapacity: [String, Number],
        seBarLayout: String,
        packCode: String, // "PF", "PFP"
        customTopStations: Array
    },
    data() {
        return {
            packColorConfig_primary,
            packColorConfig_100,
            LayoutEnum,
            dropdownWidth: '350px',
            intersectionObserverUp: null,
            intersectionObserverDown: null,
            controls: {
                regionsHeader: Events(),
                regionsTabsAutocomlete: Events(),
                startDate: Events(),
                endDate: Events(),
                participants: Events()
            },
            data: {
                total: null,
                datepickerMethods: null,
                geoData: null,
                constructedRegions: null,
                constructedDomains: null,
                constructedStations: null
            },
            off: {
                list: [],
                onRegionsDropdownClose: null
            },
            state: {
                expanded: false,
                isMobile: false,
                mobileExpanded: true,
                scrollBelowTop: false,
                opaque: 0,
                toUpdateOnExpand: false,
                showAutoComplete: false,
                regionsDropdownIsOpen: false,
                stationDropDownIsOpen: false,
            }
        }
    },
    computed: {
        packColor_primary() {
            return this.packColorConfig_primary.get(this.packCode) || this.packColorConfig_primary.get('default')
        },
        packColor_100() {
            return this.packColorConfig_100.get(this.packCode) || this.packColorConfig_100.get('default')
        },
        localStore() {
            return {
                ...this.store,
                contents: this.contents
            }
        },
        se() {
            return this.store.libs.se
        },
        regionTabs() {
            if (!this.store.data.geoData || !this.store.data.available) {
                return []
            }
            const regions = this.store.data.geoData.regions.filter((region) => {
                return this.store.data.available.regionsMap[region.id]
            })
            const regionTabs = getRegionsTabsAutocomplete({
                regions,
                countries: this.store.data.geoData.countries
            })
            return regionTabs
        },
        resultsUrl() {
            this.store.state.updateFilters // keep this statement to trigger recalculation
            //if summer, add url param criteria for POI selected
            const poiCriteria = this.store.data.selected.poi != null ? `&c[]=${this.store.data.selected.poi}&rc_start=0` : ''
            // return !this.store.state.summer ? this.se.getUrl() : this.se.getUrl() + poiCriteria

            // removeEndDate hotfix for train project
            const removeEndDate = this.isPFTTSelected()
            return this.se.getUrl(removeEndDate)
        },

        resultsUrlPackCode() {
            if (this.localStore.state.summer) {
                return this.localStore.contents.resultsUrlSummer + '#' + this.resultsUrl
            }
            return this.localStore.contents.resultsUrl + '#' + this.resultsUrl + `&packages[]=${this.packCode}`
        },
        regionLabel() {
            const regionId = this.store.data.selected.region
            return this.store.data.geoData.regionsMap[regionId]?.label
        }
    },
    methods: {
        isPFTTSelected() {
            const seState = this.se.getSeStoreState()
            const packages = seState.packages
            return packages && packages.includes("PFTT")
        },
        trackSearchButtonClick() {
            const dto = new SeStoreDTO(this.se.getSeStoreState())

            // Add the packCode for the package search engine
            if(this.packCode && !dto.packages) {
                dto.packages = [this.packCode]
            }

            trackSearchEvent(dto, this.store.data.geoData, this.seBarLayout || this.LayoutEnum.SQUARE)
        },
        closeDropdowns() {
            this.state.regionsDropdownIsOpen = false
        },
        search() {
            window.location.href = this.locallocalStore.contents.resultsUrl + '#' + this.localStore.libs.se.getUrl()
        },
        onSelectStartDate: function () {
            this.controls.endDate.fire('show')
        },
        onOpenEndDate: function () {
            if (!this.store.data.selected.startDate) {
                this.controls.endDate.fire('hide')
                this.controls.startDate.fire('show')
            }
        },
        isSelected(item) {
            // this.localStore.state.updateCounters; // keep this statement to trigger recalculation
            this.localStore.state.updateFilters // keep this statement to trigger recalculation
            return this.se.isSelected({ ...item, availableOnly: true })
        },
        isAvailable(item) {
            this.localStore.state.updateCounters // keep this statement to trigger recalculation
            return this.se.isAvailable(item)
        },
        toggle(item) {
            if (this.isSelected(item)) {
                this.remove(item)
            } else {
                this.add(item)
            }
        },
        remove(item) {
            this.se.remove(item)
        },
        add(item) {
            const available = this.se.getAvailable(item)
            this.se.add(available)
        },
        isSelectedValue(item) {
            // this.localStore.state.updateCounters; // keep this statement to trigger recalculation
            this.localStore.state.updateFilters // keep this statement to trigger recalculation
            const value = this.se.getFieldValue(item.field)
            return item.id === value
        },
        toggleFieldValue(item) {
            const isSelected = this.isSelectedValue(item)
            if (isSelected) {
                this.se.setFieldValue(item.field, undefined)
            } else {
                this.se.setFieldValue(item.field, item.id)
            }
        },
        isAvailableAvgRating(item) {
            this.localStore.state.updateCounters // keep this statement to trigger recalculation
            const counters = this.se.getCounter('averageRating')
            if (!counters) {
                return null
            }
            const counter = counters.find(({ id }) => id === item.id)
            return counter && counter.count > 0
        },
        isRegionSelected({ id }) {
            return this.store.data.selected.region === id
        },
        regionsInputOnKeyUp(e) {
            if (e.key === 'ArrowUp') {
                this.controls.regionsTabsAutocomlete.fire('up')
            }
            if (e.key === 'ArrowDown') {
                this.controls.regionsTabsAutocomlete.fire('down')
            }
            if (e.key === 'ArrowLeft') {
                this.controls.regionsTabsAutocomlete.fire('left')
            }
            if (e.key === 'ArrowRight') {
                this.controls.regionsTabsAutocomlete.fire('right')
            }
            if (e.key === 'Enter') {
                this.controls.regionsTabsAutocomlete.fire('select')
            }
        },
        openRegionsDropdown(e) {
            e.stopPropagation()
            if (this.state.regionsDropdownIsOpen) {
                this.state.regionsDropdownIsOpen = false
                this.onRegionsDropdownClose()
                return
            }

            this.state.regionsDropdownIsOpen = true
            $('body').on('click', (e) => {
                this.state.regionsDropdownIsOpen = false
            })
        },
        onRegionsDropdownOpen() {
            this.state.regionsDropdownIsOpen = true
            this.$nextTick(() => {
                this.controls.regionsTabsAutocomlete.fire('reset-scroll')
            })
        },
        onRegionsDropdownClose() {
            this.off.onRegionsDropdownClose?.()
            this.state.regionsDropdownIsOpen = false
            this.controls.regionsHeader.fire('filter', '')
            this.controls.regionsTabsAutocomlete.fire('filter', '')
            this.controls.regionsTabsAutocomlete.fire('reset-selected')
        },
        clearRegions() {
            this.controls.regionsHeader.fire('filter', '')
            this.controls.regionsTabsAutocomlete.fire('filter', '')
            this.controls.regionsTabsAutocomlete.fire('reset-selected')
            this.controls.regionsTabsAutocomlete.fire('reset-scroll')
            this.se.setFieldValue('region', undefined)
            emitRegionsValue(undefined)
        },
        selectRegion({ id }) {
            this.se.batch(() => {
                this.se.setFieldValue('domaineSki', undefined)
                this.se.setFieldValue('parentStation', undefined)
                this.se.setFieldValue('station', undefined)
                this.se.setFieldValue('region', id)
                emitParentStationsValue(undefined)
                emitStationsValue(undefined)
                emitRegionsValue(id)
            })
            this.controls.regionsHeader.fire('blur')
            this.onRegionsDropdownClose()
        },
        reset() {
            this.onRegionsDropdownClose()
            this.se.batch(() => {
                this.se.clearRequest()
                this.se.setParticipantsAges(this.defaultParticipantsAges)
                this.se.setFieldValue('capacity', this.defaultCapacity)
                this.store.data.selected.poi = null
            })
            this.store.data.selected.autocompleteValue = null
            emitAutocompleteValue(null)
        },
        onWindowSize() {
            const windowWidth = window.innerWidth
            const mobileScreenSize = 768
            if (windowWidth <= mobileScreenSize) {
                this.state.isMobile = true
            } else {
                this.state.isMobile = false
            }
        },
        startIntersectionObserver() {
            const topObj = $(this.$refs.top)
            const windowObj = $(window)
            this.intersectionObserverUp = new IntersectionObserver(
                () => {
                    const topTop = topObj.offset().top
                    const windowTop = windowObj.scrollTop()
                    if (windowTop <= topTop) {
                        this.state.scrollBelowTop = false
                        this.state.mobileExpanded = true
                    }
                },
                {
                    rootMargin: '0px'
                }
            )
            this.intersectionObserverDown = new IntersectionObserver(
                () => {
                    const topTop = topObj.offset().top
                    const windowTop = windowObj.scrollTop()
                    if (windowTop > topTop) {
                        this.state.scrollBelowTop = true
                    }
                },
                {
                    rootMargin: '1px'
                }
            )
        },
        updateExpectedCounters() {
            if (this.state.expanded) {
                this.se.setCriteriaCounters(this.expandedCriteriaCounters)
            } else {
                this.se.setCriteriaCounters(this.criteriaCounters)
            }
        },
        expandMobile() {
            this.state.mobileExpanded = true
            this.updateExpectedCounters()
            this.expandMobileUILogic()
        },
        collapseMobile() {
            this.state.mobileExpanded = false
            this.updateExpectedCounters()
        },
        expandMobileUILogic() {
            // ui updates
            const top = $(this.$refs.top).offset().top
            $(window).scrollTop(top)
            this.state.opaque = 1
            this.$nextTick(() => {
                this.state.opaque = 2
                setTimeout(() => {
                    this.state.opaque = 0
                }, 500)
            })
        },
        expand() {
            this.state.expanded = true
            this.updateExpectedCounters()
            if (this.state.toUpdateOnExpand) {
                this.se.request()
            }
        },
        collapse() {
            this.state.expanded = false
            this.updateExpectedCounters()
        },
        initTooltips() {
            $(this.$refs.wrap).tooltip({
                selector: '[data-toggle="tooltip"]'
            })
        },
        async checkStartofWinterAvailableDates() {
            const startOfWinterDate = getStartOfWinterDate()
            const availableDates = await this.store.libs.se.requestStartDates(startOfWinterDate)
            return availableDates && availableDates.length
        },
        isDateToDisplayNextWinterSeasonButton() {
            const month = new Date().getMonth();
            return  month >= nextSeasonButtonMonthStart && month <= nextSeasonButtonMonthEnd;
        },
        async isDisplayNextWinterSeasonButton() {
            const startofWinterAvailableDates = await this.checkStartofWinterAvailableDates()
            return startofWinterAvailableDates && this.isDateToDisplayNextWinterSeasonButton()
        }
    },
    beforeDestroy() {
        this.off.list.forEach((off) => off())
    },
    async mounted() {
        this.onWindowSize()
        await this.se.requestGeoDataWithEngineId()
        await this.se.request()

        this.state.showAutoComplete = true
        //Set state Season  by catching 'ete' in the url - only solution available at the time of development.
        if (window.location.href.includes('/montagne-ete/')) {
            // this.$set(this.store.state, 'summer', true)
        }
        this.off.list.push(
            this.se.on(this.se.events.COUNTERS, () => {
                if ((!this.state.isMobile && !this.state.expanded) || (this.state.isMobile && !this.state.mobileExpanded)) {
                    this.state.toUpdateOnExpand = true
                } else {
                    this.state.toUpdateOnExpand = false
                }
            }).off
        )
        // this.startIntersectionObserver()
        this.onWindowSize()
        this.updateExpectedCounters()
        this.initTooltips()
        this.se.onFieldValue(
            'station',
            () => {
                if (this.store.data.selected.stations && !this.store.data.selected.startDate) {
                    // this.controls.startDate.fire('show')
                }
            },
            true
        )

        // this is needed to respond to an autocomplete change in a parallel autocomplete in a parallel search engine if it exists; at this moment the search engines are designed to display same values, so if you have to implement separate engines, remove this piece of logic
        setAutocompleteValueListener((autocompleteValue) => {
            this.store.data.selected.autocompleteValue = autocompleteValue
        })
        setRegionsValueListener((region) => {
            this.store.data.selected.region = region
        })
        setStationsValueListener((stations) => {
            this.store.data.selected.stations = stations
        })
        setParentStationsValueListener((parentStations) => {
            this.store.data.selected.parentStations = parentStations
        })

        onClickOutside(this.$refs.regionsInput, () => {
            this.onRegionsDropdownClose()
        })

        this.store.state.showNextSeasonButton = await this.isDisplayNextWinterSeasonButton()
    }
}
</script>

<style>
@import url(./main.css);

.regions-dropdown .dropdown-menu {
    top: 77px !important;
}

.right-0 {
    right: 0;
}

.top-50pc {
    top: 50%;
}

.translate-t-n50pc {
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

#horizontal-se-grid-parent-wrapper {
    display: grid;
    grid-template-columns: 1000fr 1fr;
}

/* HORIZONTAL LAYOUT */
/* horizontal se grid layout */
#horizontal-se-grid-wrapper {
    display: grid;
    grid-template-columns: 3fr 2fr 2fr 2fr 2fr;
    /* 3fr for the autocomplete, 2fr for the other sections, auto for the buttons */
    grid-template-areas: 'autocomplete start-date end-date participants ski';
    gap: 10px;
}

#horizontal-se-grid-wrapper.SUMMER {
    display: grid;
    grid-template-columns: 3fr 2fr 2fr 2fr;
    /* 3fr for the autocomplete, 2fr for the other sections, auto for the buttons */
    grid-template-areas: 'autocomplete start-date end-date participants';
    gap: 10px;
}

#horizontal-se-autocomplete {
    grid-area: autocomplete;
}

#horizontal-se-start-date {
    grid-area: start-date;
}

#horizontal-se-end-date {
    grid-area: end-date;
}

#horizontal-se-participants {
    grid-area: participants;
}

#horizontal-se-formule-ski {
    grid-area: ski;
}

/* #horizontal-se-type-hebergement {
    grid-area: hebergement;
} */

/* / HORIZONTAL LAYOUT */

/* PACK LAYOUT */

button.ts-x-green,
button.ts-x-orange {
    border-radius: 50%;
    padding: 0.5em;
    position: relative;
    border: 0;
    width: 32px;
    height: 32px;
}

button.ts-x-green::before,
button.ts-x-orange::before {
    content: ' ';
    position: absolute;
    display: block;
    width: 2px;
    left: 15px;
    top: 8px;
    bottom: 8px;
    transform: rotate(45deg);
}

button.ts-x-green::after,
button.ts-x-orange::after {
    content: ' ';
    position: absolute;
    display: block;
    background-color: var(--grey-800);
    height: 2px;
    top: 15px;
    left: 8px;
    right: 8px;
    transform: rotate(45deg);
}

button.ts-x-green::before,
button.ts-x-green::after {
    background-color: var(--primary-green);
}

button.ts-x-orange::before,
button.ts-x-orange::after {
    background-color: var(--primary-orange);
}

.pack-plus {
    font-size: 24px;
    font-weight: 800;
    font-family: Cy;
    padding: 10px;
}

.pack-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 117px;
    height: 89px;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 0px 1px 3px 0px #1018281a, 0px 1px 8px 0px #1018281a;
}

.price-box {
    border-radius: 10px;
    padding: 15px;
}

.pack-box-wrapper {
    padding: 20px;
}

.pack-main-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* One column for most elements */
    grid-template-rows: auto;
    /* One row per section */

    grid-template-areas:
        'pack-boxes pack-boxes'
        /* "pack-price-box pack-price-box" */
        /* "pack-price-box-disclaimer pack-price-box-disclaimer" */
        'pack-region pack-region'
        'pack-station pack-station'
        'pack-participants pack-participants'
        'pack-start pack-end'
        'pack-reset pack-reset'
        'pack-search pack-search';
    grid-gap: 10px;
    /* Gap between rows, adjust as necessary */
}

@media (min-width: 768px) {
    .pack-main-grid {
        grid-template-areas:
            'pack-boxes pack-boxes'
            /* "pack-price-box pack-price-box" */
            /* "pack-price-box-disclaimer pack-price-box-disclaimer" */
            'pack-autocomplete pack-autocomplete'
            'pack-participants pack-participants'
            'pack-start pack-end'
            'pack-reset pack-reset'
            'pack-search pack-search';
    }
}

#pack-boxes {
    grid-area: pack-boxes;
}

/* #pack-price-box {
    grid-area: pack-price-box;
}

#pack-price-box-disclaimer {
    grid-area: pack-price-box-disclaimer;
} */

#pack-autocomplete {
    grid-area: pack-autocomplete;
}

#pack-participants {
    grid-area: pack-participants;
}

#pack-start {
    grid-area: pack-start;
}

#pack-end {
    grid-area: pack-end;
}

#pack-reset {
    grid-area: pack-reset;
}

#pack-search {
    grid-area: pack-search;
}

#pack-region {
    grid-area: pack-region;
}

#pack-station {
    grid-area: pack-station;
}

/* / PACK LAYOUT */
</style>
